import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { WenConfiguration } from '../../shared/models/wen-configuration.model';
import { Observable } from 'rxjs';

@Injectable()
export class WenConfigurationService {
  private readonly httpClient = inject(HttpClient);
  private readonly apiUrl = '/api/dealership';
  private _wenConfiguration: WenConfiguration | undefined;

  public retrieveWenConfiguration(): Observable<WenConfiguration> {
    return this.httpClient.get<WenConfiguration>(`${this.apiUrl}/oauth/wen`);
  }
}
